'use strict'

var printf = require('pff')
var toArray = require('to-array')
var regex = /%[sdj]/

module.exports = function format (message) {
  if (regex.test(message)) return printf.apply(null, arguments)
  return toArray(arguments).join(' ')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/simple-format/index.js
// module id = 176
// module chunks = 0